//import { useCallback, useEffect, useState } from 'react';
import { useState } from 'react';
import { useForm } from './useForm';
import { useNavigate } from 'react-router-dom';
import { PedidoCadastrar } from '../routes/RoutesNames';
import PedidoController from '../controllers/PedidoController';
import { getAddressData } from '../services/external/viacep/getCep';
import { removeSpecialCharacters } from '../shared/utils/helpers/string';
import { PedidoAdicionarProdutoRequest } from '../controllers/Types';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const usePedidoProdutoAdicionar = (produtoId: number | null) => {
  const navigation = useNavigate();
  const produto = {};
  const [loading, setLoading] = useState<boolean>(false);
  
  const { userId } = useSelector((state) => state.Authentication);

  const onSubmit = async (data: PedidoAdicionarProdutoRequest) => {

    setLoading(true);
    if(!produtoId) {
      const response = await PedidoController.PedidoProdutoAdicionar({
        ...data,
        UsuId: userId,
      });
      if (response.StatusCode === 204) {
        navigation(PedidoCadastrar);
      } else {
        toast('Houve algum erro. Verifique os dados!', {
          type: 'error',
        });
      }
    }
    setLoading(false);
  };

  const backActions = () => {
    navigation(PedidoCadastrar);
  };

  const form = useForm({
    onSubmit: onSubmit,
    initialValues: produto,
   // validationSchema: ClienteDetalheSchema,
  });

//   const getClienteById = useCallback(async () => {
//     if (!clienteId) return;
//     try {
//       setLoading(true);
//       const Response = await ClienteController.ListarUnico(clienteId);
//       //console.log(Response);
//       if (Response.Data) {
//         //console.log(Response.Data.cli_datanascimento);
//         setCliente({
//           Nome: Response.Data.cli_nome,
//           RazaoSocial: Response.Data.cli_razao,
//           CpfCnpj: Response.Data.cli_cpf_cnpj,
//           RgIe: Response.Data.cli_rg_ie,
//           DataNascimento: Response.Data.cli_datanascimento1,
//           Nacionalidade: Response.Data.cli_nacionalidade,
//           Cep: Response.Data.cli_cep,
//           Cidade: Response.Data.cli_cidade,
//           Bairro: Response.Data.cli_bairro,
//           Estado: Response.Data.cli_uf,
//           Endereco: Response.Data.cli_endereco,
//           Numero: Response.Data.cli_numero,
//           Complemento: Response.Data.cli_complemento,
//           Telefone: Response.Data.cli_telefone,
//           Celular: Response.Data.cli_celular,
//           Email: Response.Data.cli_email,
//           ClienteAtivo: Response.Data.cli_ativo,
//           GrupoCliente: Response.Data.cli_grupo,
//           //Site: Response.Data.cli_website,
//         });     
//       }

//     } catch (error) {
//       console.error('Error fetching user:', error);
//     } finally {
//       setLoading(false);
//     }
//   }, [clienteId]);

//   useEffect(() => {
//     getClienteById();
//   }, [getClienteById]);

  const handleZipCode = async (value: any) => {
    form.handleChange(value);
    const zipcode = value.target.value;

    // @ts-ignore - .
    if (zipcode && removeSpecialCharacters(zipcode).length >= 8) {
      form.handleTextChange('Cep', removeSpecialCharacters(zipcode));
      setLoading(true);
      const response = await getAddressData(zipcode);

      if (response && response.uf) {
        form.handleTextChange('Cidade', response.localidade);
        form.handleTextChange('Estado', response.uf);
        form.handleTextChange('Endereco', response.logradouro);
        form.handleTextChange('Bairro', response.bairro);
      } else {
        form.handleTextChange('Cidade', '');
        form.handleTextChange('Estado', '');
        form.handleTextChange('Endereco', '');
        form.handleTextChange('Bairro', '');
      }

      setLoading(false);
    }
  };

  return {
    ...form,
    backActions,
    loading,
    handleZipCode,
  };
};

export default usePedidoProdutoAdicionar;
